import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "tag", "color", "size"];
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { jsx as _jsx } from "react/jsx-runtime";
export var Title = props => {
  var {
    children,
    tag = 'h3',
    color,
    size = "md"
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = useTitleClass({
    color,
    size,
    tag
  });

  switch (tag) {
    case 'h1':
      return /*#__PURE__*/_jsx("h1", _extends({
        className: classes
      }, rest, {
        children: children
      }));

    case 'h2':
      return /*#__PURE__*/_jsx("h2", _extends({
        className: classes
      }, rest, {
        children: children
      }));

    case 'h3':
      return /*#__PURE__*/_jsx("h3", _extends({
        className: classes
      }, rest, {
        children: children
      }));

    case 'h4':
      return /*#__PURE__*/_jsx("h4", _extends({
        className: classes
      }, rest, {
        children: children
      }));

    case 'h5':
      return /*#__PURE__*/_jsx("h5", _extends({
        className: classes
      }, rest, {
        children: children
      }));

    default:
      return /*#__PURE__*/_jsx("div", _extends({
        className: classes
      }, rest, {
        children: children
      }));
  }
};
var useTitleClass = createMemoClass(props => {
  var borderWidths = {
    h1: "border-b-4",
    h2: "border-b-4",
    h3: "border-b-2",
    h4: "border-b-2",
    h5: "border-b-2",
    h6: "border-b"
  };
  return clsx("pb-1 border-ccq-yellow", borderWidths[props.tag]);
});
//# sourceMappingURL=title.js.map